import { useTranslation } from 'react-i18next';

export const keyPrefix = 'foldableEntity';
export const useFoldableEntityTranslation = () => useTranslation('shared', { keyPrefix });
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    empty: 'Нет данных',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    empty: 'No data',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    empty: 'Sem dados',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    empty: 'No hay datos',
  },
}) : {}) as Record<string, unknown>;
